// Maps each lighting condition (src/data/lighting.json ids) to a gradient
// and a text-contrast mode. This is presentation-only derived data — not a
// fact about the user or the product, just a design mapping — so it lives
// here as a util rather than in src/data/.
//
// The mapping is intentionally grounded in what each condition actually
// looks like (color temperature, brightness) rather than being decorative:
// golden-hour is amber, blue-hour is indigo, low-light is near-black, etc.

const LIGHTING_GRADIENTS = {
  "full-sun": { from: "#FFD98C", to: "#FF8A3D", text: "dark" },
  "partly-cloudy": { from: "#FFE9B8", to: "#C9B79C", text: "dark" },
  "overcast": { from: "#B8C4CC", to: "#5C6B75", text: "light" },
  "shade": { from: "#9FC2C7", to: "#45636B", text: "light" },
  "golden-hour": { from: "#FFB25E", to: "#B5432C", text: "light" },
  "sunrise": { from: "#FF9E80", to: "#FFC971", text: "dark" },
  "sunset": { from: "#FF7A59", to: "#6E2B5F", text: "light" },
  "blue-hour": { from: "#5C6BC0", to: "#1A1F4D", text: "light" },
  "backlit": { from: "#FFF3D6", to: "#2B2B33", text: "light" },
  "mixed-lighting": { from: "#C77DFF", to: "#6B8CFF", text: "light" },
  "indoor-bright": { from: "#FFD59E", to: "#4A3F35", text: "light" },
  "low-light": { from: "#2B2E3A", to: "#0E0F14", text: "light" },
};

const FALLBACK = { from: "#B8C4CC", to: "#5C6B75", text: "light" };

export function gradientForLighting(lightingId) {
  return LIGHTING_GRADIENTS[lightingId] || FALLBACK;
}

// Neutral "unlit camera body" gradient for collapsed camera-level cards.
export const CAMERA_NEUTRAL_GRADIENT = { from: "#2A2C32", to: "#17181C" };
